/* Hook encargado de crear y modificar el Vehiculo

Autor: Benjamín León
Fecha: 2024-10-01
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import Credit from '../interfaces/Credit.ts'

import { makeUrlCreditEdit } from './connectionData.tsx'

interface ApiParams {
  credit: Credit
  vehicle: string
  client: string
  organization: string
}
const useCreditPoster = () => {
  const [errorPostCredit, setErrorPostCredit] = useState<Error | null>(null)
  const [loadingPost, setLoadingPost] = useState<boolean>(false)

  const postCredit = async (
    credit: Credit,
    modificaSw: boolean,
    vehicleId: string,
    clientId: string,
    organizationId: string
  ) => {
    setLoadingPost(true)

    try {
      const apiUrl = makeUrlCreditEdit(modificaSw)
      const apiParams: ApiParams = {
        credit: credit,
        vehicle: vehicleId,
        client: clientId,
        organization: organizationId,
      }

      const res = await customPost<{ _id: string }>(apiUrl, apiParams)
      setErrorPostCredit(null)

      return res._id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostCredit(err)
      } else {
        setErrorPostCredit(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorPostCredit, loadingPost, postCredit }
}
export default useCreditPoster
